module.exports = __webpack_public_path__ + "img/preview.c4b5d9bc.svg";